import { types } from 'actions/types';

const DEFAULT_STATE = {
    availability: {
        "0": [""],
        "1": [""],
        "2": [""],
        "3": [""],
        "4": [""],
        "5": [""],
        "6": [""],
    },
    exceptions: {},
    localDaysOff: {},
}

export default (state = DEFAULT_STATE, action) => {

    switch (action.type) {
        case types.GET_PROVIDER_AVAILABILITY:
            return {
                ...state, availability: action.payload
            }
        case types.GET_PROVIDER_EXCEPTIONS:
            return {
                ...state, exceptions: action.payload
            }
        case types.GET_PROVIDER_DAYSOFF:
            return {
                ...state, localDaysOff: action.payload
            }
        case types.SET_AVAILABILITY_UPDATE_STATUS:
            return {
                ...state, availabilityUpdateStatus: action.payload
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/js/reducers/availability-reducer.js